// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/" + chunkId + "." + "a6a72c82" + ".chunk.js");